import config from "config";
import getImageDimensions from "./getImageDimensions";
import urlBuilder from "./urlBuilder";

const isPresignedUrl = (url: string): boolean => {
  if (!url) return false;
  return url.includes("X-Amz-Algorithm=");
};

const getImagePath = (
  imagePath: string,
  modifier = "",
  params = {},
  withWatermark = false,
  withOriginalDimension = false,
) => {
  // if presigned url, return as is
  if (isPresignedUrl(imagePath)) {
    return imagePath;
  }

  // DEV
  imagePath = imagePath?.replace(
    "https://s3-ap-southeast-1.amazonaws.com/assets-dev.amberstudent.com",
    config.IMAGE_ASSETS_URL,
  );
  imagePath = imagePath?.replace(
    "https://s3.eu-west-1.amazonaws.com/assets-dev.staging-amber.com",
    config.IMAGE_ASSETS_DEV_URL,
  );

  // PROD
  imagePath = imagePath?.replace(
    "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com",
    config.IMAGE_STATIC_URL,
  );
  imagePath = imagePath?.replace(
    "https://static-assets-amberstudent.imgix.net",
    config.IMAGE_STATIC_URL,
  );
  imagePath = imagePath?.replace(
    "https://s3.ap-southeast-1.amazonaws.com/assets.amberstudent.com",
    config.IMAGE_ASSETS_URL,
  );
  imagePath = imagePath?.replace(
    "https://s3-ap-southeast-1.amazonaws.com/assets.amberstudent.com",
    config.IMAGE_ASSETS_URL,
  );
  imagePath = imagePath?.replace("https://assets-amberstudent.imgix.net", config.IMAGE_ASSETS_URL);
  imagePath = imagePath?.replace("https://assets.amberstudent.com", config.IMAGE_ASSETS_URL);

  imagePath = imagePath?.replace("https://prod-assets.amberstudent.com", config.IMAGE_ASSETS_URL);
  imagePath = imagePath?.replace(
    "https://prod-static-assets.amberstudent.com",
    config.IMAGE_STATIC_URL,
  );
  imagePath = imagePath?.replace(
    "https://uploads-ssl.webflow.com/62b98fc5bea88fd1216dd4b9",
    config.WEBFLOW_ASSET_URL,
  );

  imagePath = imagePath?.replace("https://uploads-ssl.webflow.com", config.WEBFLOW_ASSET_URL);

  let queryParams: { auto?: string; trim?: string } = {};
  queryParams = getImageDimensions(modifier);
  if (!withOriginalDimension) {
    queryParams.auto = "format";
    queryParams.trim = "auto";
  }
  queryParams = Object.assign(queryParams, params);
  if (withWatermark) {
    const watermarkParams = {
      text: "amber",
      text_position: "bottomright",
      text_padding: 20,
      text_color: "#ffffffb3",
      text_font_size: 24,
    };
    queryParams = Object.assign(queryParams, watermarkParams);
  }
  return urlBuilder(imagePath || "", { params: queryParams });
};

export default getImagePath;
